import { TThunkAction } from '../../types/redux';
import { getEstimationByDealType } from './getEstimationByDealType';
import { getEstimationRequest, IGetEstimationSuccessPayload } from './actions';
import { updateUrl } from '../page';
import { validateAddress } from './validateAddress';
import { EScrollingBlocks } from '../../constants/scrollingBlocks';
import { selectDealType } from '../../selectors/page';
import { getEstimationChartData } from '../estimationChart';
import { getReversDealType } from '../../utils/getReversDealType';

/**
 * Общая между node & browser часть процесса загрузки оценки
 * 1. провалидировать адрес и получить houseId =realtyId (если требуется)
 * 2. Запросить оценку, передав полученные похожие офферы и все остальные фильтры
 * 3. Обновить Query строку
 * */
export const getEstimateWithParameters =
  (options: IOptions = {}, params: IParams = {}): TThunkAction<Promise<IGetEstimationSuccessPayload | Error>> =>
  async (dispatch, getState, context) => {
    const { validateFilters } = options;
    const { scrollToBlock } = params;

    const state = getState();

    const dealType = selectDealType(state);
    const reversDealType = getReversDealType(dealType);

    dispatch(getEstimationRequest({ dealType }));

    try {
      if (validateFilters) {
        const maybeErr = await dispatch(validateAddress());

        /** Если произошла ошибка при валидации, оценку не грузим, ошибку возвращаем */
        if (maybeErr instanceof Error) {
          return maybeErr;
        }
      }

      /**
       * Сразу дергаем данные для продажи и аренды
       * (затемняем недоступный таб выбора типа сделки, если данных нет)
       */
      const [result] = await Promise.all([
        dispatch(getEstimationByDealType(dealType)),
        dispatch(getEstimationByDealType(reversDealType)),
        dispatch(getEstimationChartData()),
      ]);

      if (result instanceof Error) {
        return result;
      }

      dispatch(updateUrl());

      /**
       * Если передана функция скролла к блоку и получили новую цену:
       *  скролим к результатам оценки
       */
      if (result.data?.price && scrollToBlock) {
        scrollToBlock(EScrollingBlocks.MarketPrice);
      }

      return result;
    } catch (e) {
      context.logger.error(e);

      return e as Error;
    }
  };

interface IOptions {
  validateFilters?: boolean;
}

interface IParams {
  scrollToBlock?(blockId: EScrollingBlocks): void;
}
